import { ImageComponent } from '@/components/Image';
import { ScLoyaltyProgramIcon } from './styled';

export const LoyaltyProgramIcon = ({ level }: any) => {
  const image = level.image;
  const blurStyle = { background: level.blur };

  return (
    <ScLoyaltyProgramIcon>
      <div className="blur" style={blurStyle} />
      <ImageComponent
        alt="logo"
        height={32}
        objectFit="contain"
        src={image?.url || ''}
        width={32}
      />
    </ScLoyaltyProgramIcon>
  );
};
